export default function(filename: string, content: string): void {
    const a = document.createElement('a');
    const file = new Blob([content], {type: 'text/plain'});

    a.href = URL.createObjectURL(file);
    a.style.display = 'none';
    a.download = filename;

    a.click();
    URL.revokeObjectURL(a.href);
    a.remove();
}
